import { PartialLookDetail } from 'Client/redux/lookDetail/types';
import { BrazeCustomEvent } from './braze';
import { ProductInterface } from './PDPProduct';

export const CartFlyoutTimeoutKey = 'ww_cart_flyout_timeout';

export enum OverlayIds {
    LOGIN_AND_REGISTER = 'LOGIN_AND_REGISTER',
    ALICE_SHOP2CLUB = 'SHOP2CLUB',
}

export enum EventNames {
    UPDATE_LOGIN_STATE = 'UPDATE_LOGIN_STATE',
    UPDATE_WISHLIST = 'UPDATE_WISHLIST',
    UPDATE_CART = 'UPDATE_CART',
    UPDATE_OVERLAYS = 'UPDATE_OVERLAYS',
    SIMULATE_BRAZE_PRODUCT_RATINGS = 'SIMULATE_BRAZE_PRODUCT_RATINGS',
    NOTIFICATION = 'NOTIFICATION',
    LOOKS_WISHLIST = 'LOOKS_WISHLIST',
    LOOK_DETAIL_PAGE = 'LOOK_DETAIL_PAGE',
    PRODUCT_DETAIL_PAGE = 'PRODUCT_DETAIL_PAGE',
    SEND_BRAZE_CUSTOM_EVENT = 'SEND_BRAZE_CUSTOM_EVENT',
}

export enum GenericActions {
    REFRESH = 'REFRESH',
    SEND = 'SEND',
}

export enum UpdateLoginSateActions {
    LOGIN = 'LOGIN',
    LOGOUT = 'LOGOUT',
    EXISTING_USER_LOGIN_FAIL = 'EXISTING_USER_LOGIN_FAIL',
}

export enum DisplayActions {
    SHOW = 'SHOW',
    HIDE = 'HIDE',
}

export enum StoreActions {
    FETCH = 'FETCH',
    ADD = 'ADD',
    REMOVE = 'REMOVE',
    PRE_FILL = 'PRE_FILL',
}

export enum DisplayType {
    default = 'DEFAULT',
    warning = 'WARNING',
    error = 'ERROR',
    hint = 'HINT',
}

export interface UpdateOverlayDetail {
    action: DisplayActions;
    id: OverlayIds;
    options?: UpdateOverlayOptions;
}

export interface UpdateCartDetail {
    action: GenericActions;
    shouldShowCartFlyout: boolean;
}

export interface UpdateOverlayOptions {
    isLogin?: boolean;
    redirectUrl?: string;
    email?: string;
}

export interface Event {
    name: EventNames;
    event: (e: EventsType[EventNames]) => void;
}

export enum ShopToClubShownLabel {
    Default = '',
    Banner = 'Promo header banner click',
    PageLoad = '2nd page load',
}

export interface OverlayOptionsType {
    isLogin: boolean;
    data?: { trackingLabel: ShopToClubShownLabel };
}

export type EventNamesType = keyof EventsType;
export type OverlayIdsType = keyof typeof OverlayIds;
export type DisplayOptionsType = keyof typeof DisplayType;
export type DisplayActionsType = keyof typeof DisplayActions;
export type GenericActionsType = keyof typeof GenericActions;
export type UpdateLoginSateActionsType = keyof typeof UpdateLoginSateActions;
export type StoreActionsType = keyof typeof StoreActions;

export type EventsType = {
    UPDATE_WISHLIST: {
        detail: {
            action: GenericActionsType;
        };
    };
    NOTIFICATION: {
        detail: {
            action: DisplayActionsType;
            message: string;
            autoHideInterval?: number | 'sticky' | null;
            displayType: DisplayOptionsType;
        };
    };
    UPDATE_OVERLAYS: {
        detail: {
            action: DisplayActionsType;
            id: string;
            options?: OverlayOptionsType;
        };
    };
    UPDATE_LOGIN_STATE: {
        detail: {
            action: UpdateLoginSateActionsType;
        };
    };
    UPDATE_CART: {
        detail: {
            action: GenericActionsType;
            shouldShowCartFlyout: boolean;
        };
    };
    SIMULATE_BRAZE_PRODUCT_RATINGS: {};
    LOOKS_WISHLIST: {
        detail: {
            action: StoreActionsType;
            slug: string;
        };
    };
    LOOK_DETAIL_PAGE: {
        detail: {
            action: StoreActionsType;
            look: PartialLookDetail;
        };
    };
    PRODUCT_DETAIL_PAGE: {
        detail: {
            action: StoreActionsType;
            product: ProductInterface;
        };
    };
    SEND_BRAZE_CUSTOM_EVENT: {
        detail: {
            action: GenericActionsType;
            event: BrazeCustomEvent;
        };
    };
};
